import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, delay, filter, map, mergeMap, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { AlertService } from '../../commons/services/alert.service';
import { AppState } from '../reducers';
import { getSelectedStoreTenant } from '../selectors/tenant.selectors';
import * as OrdersActions from '../../store/actions/orders.actions';
import * as OrdersSelectors from '../../store/selectors/orders.selectors';
import { LaravelOrderService } from '../../commons/services/laravel/laravel-order.service';
import { OrderService } from '../../commons/services/order.service';
import { Order, OrderDTO } from '../../commons/models/order';
import { Router } from '@angular/router';
import { OrdersListComponent } from '../../modules/home/modules/orders/components/orders-list/orders-list.component';
import { OrderModalComponent } from '../../modules/home/modules/orders/components/order-modal/order-modal.component';

@Injectable() 
export class OrdersEffects {
    error$ = createEffect(
        () =>
            this.actions$.pipe(
            ofType(
                //OrdersActions.deleteOrderFailed,
                //OrdersActions.saveOrderFailed
            ),
            tap(({ error }) => {
                if (error) {
                this.alertService.showErrorMessage('Errore', error);
                }
            })
            ),
        { dispatch: false }
    );

    loadOrders$ = createEffect(() =>
        this.actions$.pipe(
          ofType(OrdersActions.loadOrders),
          withLatestFrom(this.store$.select(getSelectedStoreTenant)),
          map(([{ page, per_page, order, direction, filters, zoneIds, statuses, date, customer_id, deliveryman_id, include_pick, include_delivery, with_sweets, include_archived, include }, tenant]) => {
            const filter = { ...filters };
            if (filters.onlyCurrentTenant) {
              filter.tenant_id = tenant.id;
            }
            return { page, per_page, order, direction, filters: filters, zoneIds, statuses, date, customer_id, deliveryman_id, include_pick, include_delivery, with_sweets, include_archived, include};
          }),
          switchMap(({ page, per_page, order, direction, filters, zoneIds, statuses, date, customer_id, deliveryman_id, include_pick, include_delivery, with_sweets, include_archived, include }) => {
            console.log('Calling API...');
            // return this.ordersService.getDailyOrders(
            //   zoneIds,
            //   statuses,
            //   date,
            //   customer_id,
            //   include_pick,
            //   include_delivery,
            //   include_archived
            // )
            return this.orderService
            .list(page, per_page, order, direction, filters, zoneIds, statuses, date, customer_id, deliveryman_id, include_pick, include_delivery, with_sweets, include_archived, include)
            .pipe(
              map((result) => {
                console.log('API success:', result);
                //const orders: OrderDTO[] = result.data.map(dto => new Order(dto).toDTO());
                return OrdersActions.loadOrdersSuccess({
                  orders: result.data,
                  filters,
                });
              }),
              catchError((error) =>
                of(OrdersActions.loadOrdersFailed({ error }))
              )
            );
          })
        )
      );     
      

    saveOrders$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrdersActions.saveOrder),
        withLatestFrom(this.store$.select(getSelectedStoreTenant)),
        mergeMap(([{ order }, selectedTenant]) => {
          let tenantId = selectedTenant ? selectedTenant.id : null;
          //console.log("Tenant id nel saveOrder effect:", tenantId)
          let orderSave = { 
            ...order.toDTO(),
            tenant_id: tenantId
          };
          return this.orderService.upsert(orderSave).pipe(
              map((result) =>
                  OrdersActions.createOrdersSuccess({ order: result })
              ),
              // catchError((error) =>
              // of(OrdersActions.saveOrderFailed({ error }))
            
            tap((action) => {
                if (action.type === OrdersActions.createOrdersSuccess.type) {
                  this.alertService.showConfirmMessage(`Ordine salvato con successo`)
                  this.store$.dispatch(OrdersActions.closeOrdersDialog());
                  this.router.navigate(['/orders/list']);
                } else {
                  this.store$.dispatch(OrdersActions.createOrderFailure({ error: Error }));
                }
              })
          );
          
        })
      )
    );

    updateOrder$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrdersActions.updateOrder),
        withLatestFrom(this.store$.select(getSelectedStoreTenant)),
        mergeMap(([{ order }, selectedTenant]) => {
          let tenantId = selectedTenant ? selectedTenant.id : null;
          let orderUpdate = {
            ...order.toDTO(),
            tenant_id: tenantId
          };
    
          return this.orderService.upsert(orderUpdate).pipe(
            map((result) => OrdersActions.updateOrderSuccess({ order: result })),
            catchError((error) => of(OrdersActions.updateOrderFailure({ error }))),
            tap((action) => {
              if (action.type === OrdersActions.updateOrderSuccess.type) {
                this.alertService.showConfirmMessage(`Ordine #${order.id} modificato con successo`);
                this.dialog.closeAll();
                this.store$.dispatch(OrdersActions.loadOrders({ page: 1, per_page: 10 }));
              } else {
                this.store$.dispatch(OrdersActions.updateOrderFailure({ error: Error }));
              }
            })
          );
        })
      )
    );

    
    

    // editOrder$ = createEffect(() =>
    //   this.actions$.pipe(
    //     ofType(OrdersActions.editOrder),
    //     withLatestFrom(
    //       this.store$.select(OrdersSelectors.selectZones),
    //       this.store$.select(OrdersSelectors.selectProducts)
    //     ),
    //     map(([{ order }, zones, products]) => {
    //       // Verifica se zones e products sono vuoti, gestisci il caso
    //       if (!Array.isArray(zones) || zones.length === 0) {
    //         console.error("Le zone non sono disponibili.");
    //         return OrdersActions.zoneDataNotAvailable();  // Azione per gestire il caso in cui le zone non sono pronte
    //       }
    
    //       if (!Array.isArray(products) || products.length === 0) {
    //         console.error("I prodotti non sono disponibili.");
    //         return OrdersActions.productDataNotAvailable();  // Azione per gestire il caso in cui i prodotti non sono pronti
    //       }
    
    //       // Se i dati sono presenti, apri il dialogo
    //       const dialogConfig = new MatDialogConfig();
    //       dialogConfig.disableClose = true;
    //       dialogConfig.autoFocus = true;
    //       dialogConfig.height = "100%";
    //       dialogConfig.maxWidth = "100vw";
    //       dialogConfig.width = "100vw";
    //       dialogConfig.panelClass = "no-padding";
    //       dialogConfig.data = { order, zones, products };
    
    //       let dialogRef = this.dialog.open(OrderModalComponent, dialogConfig);
    
    //       return OrdersActions.orderDialogOpened({ dialogId: dialogRef.id });
    //     })
    //   )
    // );
    
    

    constructor(
        private actions$: Actions,
        private store$: Store<AppState>,
        private orderService: LaravelOrderService,
        private ordersService: OrderService,
        private dialog: MatDialog,
        private router: Router,
        private alertService: AlertService
    ) {}
}
